export const COMPANY = {
  nome: "Desentupidora em Guarulhos",
  razaoSocial: "Desentupidora Guarulhos",
  cnpj: "82.876.922/0001-21",
  telefone: "(11) 97195-0197",
  telefoneRaw: "011971950197",
  whatsapp: "https://api.whatsapp.com/send/?phone=5511971950197&type=phone_number&app_absent=0",
  endereco: "R. Marret, 412",
  cidade: "Guarulhos",
  estado: "SP",
  cep: "07111-000",
  dominio: "https://desentupidoraemguarulhos.site",
  horario: "Atendimento 24 horas, 7 dias por semana, inclusive feriados",
  geo: { lat: -23.4543, lng: -46.5337 },
};

export const waLink = (msg) =>
  `${COMPANY.whatsapp}&text=${encodeURIComponent(msg || "Olá! Preciso de um desentupimento urgente em Guarulhos.")}`;
